import React, { useState, useEffect } from "react";
import {connect} from 'react-redux';
import {Actions as ACTIONS} from '../../store/actions/leaveActions';
import {format,addMonths,lastDayOfMonth} from 'date-fns';
import _ from 'lodash';

const LeaveBalanceRow = ({
    
    employee,
    employeeLeaveBalances,
    otherLeaveTypes,
    proRataLeave,
    viewType,
    includeFuture,
    jurisdiction
  }) => {

    if (Object.keys(employeeLeaveBalances).length == 0){
      return null
    }

  if (viewType?.value == 'consumed'){
    return (
      <tr>
        {employee?.employeeName && 
          <td>
            {employee?.employeeName} {employee?.employeeSurname}
          </td>
        }
        <td>
          {employeeLeaveBalances.vlCf}
        </td>
        <td>
          {proRataLeave ? employeeLeaveBalances.vlE2D : employeeLeaveBalances.vlE}
        </td>
        <td>
          {employeeLeaveBalances.vlAdj}
        </td>
        <td>
          {employeeLeaveBalances.vlToil}
        </td>
        <td>
          {employeeLeaveBalances.vlConsumed}
        </td>
        <td>
          {employeeLeaveBalances.vlPaid}
        </td>
        <td>
          {proRataLeave ? employeeLeaveBalances.vl2D : employeeLeaveBalances.vlTotalBal}
        </td>
        <td>
          {employeeLeaveBalances.sick}
        </td>
        {jurisdiction === "MT" ? <td>
          {employeeLeaveBalances.sickHP}
        </td> : null}
        <td>
          {employeeLeaveBalances.sickUnpaid}
        </td>
        {otherLeaveTypes && otherLeaveTypes.map(id => (
          <td>
            {employeeLeaveBalances[id]}
          </td>
        ))}
      </tr>
    )
  }

  return (
    <tr>
      {employee?.employeeName && 
        <td>
          {employee?.employeeName} {employee?.employeeSurname}
        </td>
      }
      <td>
        {employeeLeaveBalances.vlCf}
      </td>
      <td>
        {proRataLeave ? employeeLeaveBalances.vlE2D : employeeLeaveBalances.vlTY}
      </td>
      <td>
        {proRataLeave ? employeeLeaveBalances.vl2D : employeeLeaveBalances.vlTotalBal}
      </td>
      <td>
        {employeeLeaveBalances.sick}
      </td>
      {jurisdiction === "MT" ?
        <td>
          {employeeLeaveBalances.sickHP}
        </td>
      :null}
      {otherLeaveTypes && otherLeaveTypes.map(id => (
        <td>
          {employeeLeaveBalances[id]}
        </td>
      ))}
    </tr>
  )
}


const mapStateToProps = (state,ownProps) => {

  const {
    // leave,
    leaveTypes,
    leaveBalancesByType,
    // proRataLeave,
  } = state.leave

  const {
    employee,
    viewType
  } = ownProps

  const employeeOriginalLeaveBalances = {}
  const includeFuture = state?.leave?.futureLeaveBalance
  const employeeLeaveBalances = {}
  const otherLeaveTypes = []

  const leaveTypeIDs = leaveBalancesByType && Object.keys(leaveBalancesByType)

  if (leaveTypeIDs){
    leaveTypeIDs.map(leaveTypeID => {
      const leaveTypeBalance = leaveBalancesByType[leaveTypeID].find(item => item.agreementId == employee?.id)
      console.log('leaveTypeBalance',leaveTypeBalance,employee?.id)

      if (leaveTypeBalance){
        if (viewType?.value == 'consumed'){

          if (leaveTypeID == 6020){

            employeeLeaveBalances.vlCf = leaveTypeBalance?.carryover?.toFixed(2)
            employeeLeaveBalances.vlE = leaveTypeBalance?.entitledThisYear?.toFixed(2)
            employeeLeaveBalances.vlConsumed = includeFuture ? (leaveTypeBalance?.consumed + leaveTypeBalance?.futureDated)?.toFixed(2) : leaveTypeBalance?.consumed?.toFixed(2)
            employeeLeaveBalances.vlTotalBal = includeFuture ? (leaveTypeBalance?.balanceThisYear - leaveTypeBalance?.futureDated)?.toFixed(2) : leaveTypeBalance?.balanceThisYear?.toFixed(2)
            employeeLeaveBalances.vlPaid = leaveTypeBalance?.paidLeaveHours?.toFixed(2)
            employeeLeaveBalances.vlToil = leaveTypeBalance?.toil?.toFixed(2)
            employeeLeaveBalances.vlAdj = leaveTypeBalance?.manualAdjustment?.toFixed(2)

            employeeLeaveBalances.vlE2D = leaveTypeBalance?.entitledToDate?.toFixed(2)
            employeeLeaveBalances.vl2D = includeFuture ? (leaveTypeBalance?.balanceToDate - leaveTypeBalance?.futureDated)?.toFixed(2) : leaveTypeBalance?.balanceToDate?.toFixed(2)

          } else if (leaveTypeID == 6022){

            employeeLeaveBalances.sick = leaveTypeBalance && (leaveTypeBalance.consumed || 0).toFixed(2)
            employeeLeaveBalances.sickHP = leaveTypeBalance && ((leaveTypeBalance.halfPayRegular + leaveTypeBalance.halfPayCasual) || 0).toFixed(2)
            employeeLeaveBalances.sickUnpaid = leaveTypeBalance && (leaveTypeBalance.balanceThisYear < 0 ? -leaveTypeBalance.balanceThisYear : 0).toFixed(2)
            
          } else {

            employeeLeaveBalances[leaveTypeID] = leaveTypeBalance?.consumed
            otherLeaveTypes.push(leaveTypeID);

          }

          employeeOriginalLeaveBalances[leaveTypeID] = leaveTypeBalance;

        }else {

          if (leaveTypeID == 6020){

            employeeLeaveBalances.vlCf = leaveTypeBalance && Math.max(leaveTypeBalance.carryover - leaveTypeBalance.consumed,0).toFixed(2)
            employeeLeaveBalances.vlTY = leaveTypeBalance && (leaveTypeBalance.balanceThisYear - employeeLeaveBalances.vlCf).toFixed(2)
            employeeLeaveBalances.vlTotalBal = includeFuture ? (leaveTypeBalance?.balanceThisYear - leaveTypeBalance?.futureDated).toFixed(2) : (leaveTypeBalance?.balanceThisYear || 0)?.toFixed(2)

            employeeLeaveBalances.vlE2D = leaveTypeBalance && (leaveTypeBalance?.balanceToDate - employeeLeaveBalances?.vlCf).toFixed(2)
            employeeLeaveBalances.vl2D = leaveTypeBalance?.balanceToDate?.toFixed(2)

          } else if (leaveTypeID == 6022){

            employeeLeaveBalances.sick = leaveTypeBalance && (leaveTypeBalance?.balanceThisYear || 0).toFixed(2)
            employeeLeaveBalances.sickHP = leaveTypeBalance && (leaveTypeBalance?.halfPayBalance || 0).toFixed(2)
            
          } else {

            employeeLeaveBalances[leaveTypeID] = leaveTypeBalance?.balanceThisYear
            otherLeaveTypes.push(leaveTypeID);

          }

          employeeOriginalLeaveBalances[leaveTypeID] = leaveTypeBalance;

        }
      }
    })
  }

  console.log('employeeLeaveBalances',leaveTypeIDs,employeeLeaveBalances)

  return {
    employeeLeaveBalances,
    employeeOriginalLeaveBalances,
    otherLeaveTypes,
    proRataLeave: state?.leave?.leaveSettings?.proRataLeave || state?.leave?.leaveSettings?.projectedBalance,
    jurisdiction: state?.company?.settings?.jurisdiction,
    // leaveType: leaveTypes && leave && _.find(leaveTypes,{id :leave.type}).name,
    // canEdit,
    // isSaving
  }
}

const mapDispatchToProps = dispatch => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveBalanceRow) 